import styled from 'styled-components';
import { FC } from 'react';

const BContextSelectIconWrapper = styled.div`
    width: 24px;
    height: 24px;
    cursor: pointer;
    //opacity: 1;
    transition: opacity 0.2s;
    :hover {
        //opacity: 0.7;
    }
`;

/**
 * Иконка с выбором контекста
 * @param onClick
 * @constructor
 */
export const BContextSelectIcon: FC<{ onClick?: () => void }> = ({ onClick }) => {
    return (
        <BContextSelectIconWrapper onClick={onClick}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M11.5 6V3.5H20.5V12.5H18V7.15385C18 6.51659 17.4834 6 16.8462 6H11.5ZM10 6V3.15385C10 2.51659 10.5166 2 11.1538 2H20.8462C21.4834 2 22 2.51659 22 3.15385V12.8462C22 13.4834 21.4834 14 20.8462 14H18V16.8462C18 17.4834 17.4834 18 16.8462 18H14V20.8462C14 21.4834 13.4834 22 12.8462 22H3.15385C2.51659 22 2 21.4834 2 20.8462V11.1538C2 10.5166 2.51659 10 3.15385 10H6V7.15385C6 6.51659 6.51659 6 7.15385 6H10ZM7.5 10H12.8462C13.4834 10 14 10.5166 14 11.1538V16.5H16.5V7.5H7.5V10ZM3.5 11.5V20.5H12.5V11.5H3.5Z" fill="#909090"/>
          </svg>
        </BContextSelectIconWrapper>
    );
};
import styled from 'styled-components';
import { FC } from 'react';

const BContextSelectIconWrapper = styled.div`
    width: 24px;
    height: 24px;
    cursor: pointer;
    //opacity: 1;
    transition: opacity 0.2s;
    :hover {
        //opacity: 0.7;
    }
`;

/**
 * Иконка с выбором контекста
 * @param onClick
 * @constructor
 */
export const BContextSelectIcon: FC<{ onClick?: () => void }> = ({ onClick }) => {
    return (
        <BContextSelectIconWrapper onClick={onClick}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M11.5 6V3.5H20.5V12.5H18V7.15385C18 6.51659 17.4834 6 16.8462 6H11.5ZM10 6V3.15385C10 2.51659 10.5166 2 11.1538 2H20.8462C21.4834 2 22 2.51659 22 3.15385V12.8462C22 13.4834 21.4834 14 20.8462 14H18V16.8462C18 17.4834 17.4834 18 16.8462 18H14V20.8462C14 21.4834 13.4834 22 12.8462 22H3.15385C2.51659 22 2 21.4834 2 20.8462V11.1538C2 10.5166 2.51659 10 3.15385 10H6V7.15385C6 6.51659 6.51659 6 7.15385 6H10ZM7.5 10H12.8462C13.4834 10 14 10.5166 14 11.1538V16.5H16.5V7.5H7.5V10ZM3.5 11.5V20.5H12.5V11.5H3.5Z" fill="#909090"/>
          </svg>
        </BContextSelectIconWrapper>
    );
};
